// canvas_read is a silent lookup — the user already sees the canvas in the
// main slot, so surfacing a tool card for "agent read the canvas" is just
// noise. Returning null hides it from the chat stream.
export function CanvasReadCard() {
  return null;
}
